export default "__VITE_ASSET__BKNoRZ$2__"